import React from 'react';
import Footer from '../common/Footer';
import Header from '../common/Header';

const Privacy = () => {
  return (
    <>
      <Header currentAnchor={''} links/>
      <div className="document">
        <div className="container">
          <h1>POLITIQUE DE CONFIDENTIALITÉ</h1>
          <p>Clean Bill (le Fournisseur), en tant que transporteur de données, accorde beaucoup d’importance à la vie
          privée de ses Clients et Utilisateurs, quel que soit le support, Application mobile ou Site Internet (les
          Solutions Clean Bill). Clean bill prend au sérieux ses responsabilités en matière de traitement des données
          personnelles et veille ainsi à la protection des données de ses Clients.
          La présente politique de confidentialité informe les Clients sur la manière dont Clean Bill collecte, utilise
          et divulgue les données personnelles de ses Clients.</p>

          <h2>Au sujet de la présente Politique de Confidentialité</h2>
          <p>La présente Politique de Confidentialité s’applique lorsque le Client accède aux Solutions Clean Bill
          (Application et Site Internet) ou bien lors des échanges entre Clean Bill, le Client et le Commerçant.
          La Présente politique de confidentialité peut être complétée par des éléments supplémentaires précisés dans
          tout ou partie d’un service fourni (Conditions Générales d’Utilisation de l’Application et du Site notamment).
          Clean Bill est aussi responsable de vos données personnelles en sa qualité de responsable de traitement.
          Lorsque le Client accède à l’une des Solutions Clean Bill, il peut être amené à fournir des données
          personnelles. Le Client peut choisir de ne pas transmettre ses données mais cela pourra limiter son accès aux
          services.</p>

          <h2>Les données collectées</h2>
          <p>Clean Bill collecte les données que le Client renseigne directement via l’Application ou le Site Internet et
          les données issues de l’usage des Solutions Clean Bill.
          En téléchargeant l’Application ou en créant un compte sur le Site Internet, le Client renseigne notamment son
          genre, son nom, son prénom, sa date de naissance, son numéro de téléphone, ses adresses électronique et
          postale. Il crée également un identifiant et un mot de passe.
          Lors de la souscription à l’option Pro, le Client renseigne également le nom de la Société au nom de laquelle
          les Reçus sont émis.
          Les commentaires via la plateforme d’échange avec les commerçants sont également des données accessibles au
          Fournisseur.
          Les intérêts et préférences de communication ou de fonctionnement du compte Client sont également recensés.
          Le Fournisseur peut collecter automatiquement des informations sur la manière dont le Client interagit avec
          les Solutions Clean Bill via l’utilisation de cookies, y compris :
          <ul>
            <li>Les informations concernant l’ordinateur ou le smartphone, l’environnement de connexion, à savoir
              l’adresse
              IP et la version du navigateur, le système d’exploitation et autres logiciels installés dans
              l’environnement
              du Client, le ou les identifiants techniques, rapports d’erreur et données d’exécution.
            </li>
            <li>Les données d’utilisations telles que les fonctions que le Client a utilisées, les configurations qu’il
              a
              sélectionnées, les données sur lesquelles il a cliqué, y compris la date et l’heure de ses agissements sur
              les
              Solutions Clean Bill.
            </li>
          </ul>
          Ces données sont collectées par le biais des serveurs et de l’utilisation de cookies et d’autres technologies.
          Clean Bill peut utiliser des cookies et d’autres technologies pour stocker les préférences du Client et ses
          configurations, analyser les opérations effectuées. Toutefois, si le Client bloque certains cookies, l’accès
          aux Solutions Clean Bill pourra être limité.
          </p>

          <h2>L’utilisation des données collectées</h2>
          <p>Les données personnelles sont utilisées pour :
            <ul>
              <li>Fournir, activer et gérer les accès aux Solutions Clean Bill ;</li>
              <li>Traiter et répondre à une demande, une proposition commerciale, une souscription à un module ou à tout
              autre transaction ;
              </li>
              <li>Fournir un support technique, un service ou produit complémentaire et permettre ainsi le bon
              fonctionnement du Service et sa sécurisation ;
              </li>
              <li>Améliorer les Solutions Clean bill et développer de nouvelles fonctionnalités ;</li>
              <li>Offrir un contenu personnalisé tant sur l’Application que sur le Site Internet ;</li>
              <li>Notifier les annonces publicitaires des Commerçants ;</li>
              <li>Fournir des messages et autres informations sur les Solutions Clean Bill ;</li>
              <li>Identifier les tendances d’utilisation et développer l’analyse de données, y compris pour la
              recherche, l’audit, le reporting ;
              </li>
              <li>Se conformer aux exigences légales et règlementaires, résoudre d’éventuels litiges et faire respecter
              les contrats.
              </li>
            </ul>
          </p>

          <h2>Le partage des données</h2>
          <p>
          Si le client accède aux Solutions Clean Bill, ses données personnelles et certaines données d’utilisation
          collectées peuvent être accessibles et partagées avec le commerçant qui a émis les Reçus stockés aux fins
          d’analyse des habitudes de consommations et de l’utilisation des Solutions.
          Les données transmises se limitent au genre, à l’âge et au code postal des clients. En aucun cas les noms,
          prénoms ou coordonnées téléphoniques, électroniques ou postale (autre que le code postal) ne seront transmis.
          Les données peuvent également être divulguées pour :
          Se conformer à toute loi en vigueur, règlementation, procédure juridique ou autres obligations légales en
          France ou dans les pays où sont conservées les données ;
            <ul>
              <li>Détecter, enquêter et permettre de prévenir des problèmes de sécurité, de fraude ou des problèmes
              techniques ;
              </li>
              <li>Protéger les droits, propriété ou la sécurité de Clean Bill, ses utilisateurs, employés ou autres.</li>
            </ul>
          Aucune donnée n’est vendue ni aux enseignes ni à quelconque tierce personne. Les données transmises le sont
          sous
          forme de statistiques dans lesquelles n’apparaissent, tout au plus, que le genre, l’âge et le code postal du
          Client.
          </p>

          <h2>Les finalités du traitement</h2>
          <p>
          La collecte et le traitement des données se fait dans le respect des lois sur la protection des données
          européennes :
            <ul>
              <li>Si nécessaire pour fournir le Service de stockage et d’accès aux Reçus, remplir une transaction ;</li>
              <li>Si nécessaire pour se conformer à la loi applicable ou toutes autres obligations légales ;</li>
              <li>Si nécessaire pour prévenir la fraude, permettre aux Clients de se conformer à leurs obligations légales
              et règlementaires ;
              </li>
            </ul>
          Si nécessaires pour le fonctionnement des Solutions Clean Bill, à moins que ne prévalent les intérêts du
          Client ou ses libertés et droits fondamentaux exigeant une protection de ses données à caractère personnel
          supérieure aux intérêts légitimes de Clean Bill.
          Le Client peut à tout moment retirer son accord pour l’utilisation et le traitement de ses données
          personnelles.
          </p>

          <h2>Conservation des données</h2>
          <p>
          Les données sont conservées aussi longtemps que nécessaire pour assurer les fonctionnalités des Solutions
          Clean
          Bill, notamment pour respecter les obligations légales, la tenue d’archives commerciales et financières, le
          maintien de la sécurité, la détection, la prévention de la fraude et de l’abus et l’exécution du contrat liant
          Clean Bill à ses Clients.
          Les données sont également conservées après résiliation des souscriptions aux Solutions Clean Bill pour
          assurer
          les durées minimales de conservation des données.
          Les données sont également conservées sur les supports matériels utilisés pour l’accès aux Solutions Clean
          Bill.
          </p>

          <h2>Emplacement du traitement – transfert de données personnelles</h2>
          <p>
          Les données personnelles peuvent être stockées ou traitées dans tous locaux ou pays dans lesquels Clean bill
          ou ses fournisseurs et sous-traitants gèrent leurs serveurs. Clean Bill prend les mesures nécessaires, y compris
          par le biais de contrat, pour assurer que les informations continuent à être protégées là où elles sont
          localisées en toute cohérence avec les normes de protection imposées par la loi en vigueur.
          </p>

          <h2>Sécurité des données</h2>
          <p>
          Clean Bill met en œuvre des techniques appropriées pour chercher à assurer un niveau de sécurité adapté au
          risque du traitement de données personnelles. Le but de ces mesures est d’assurer l’intégrité, la
          confidentialité et l’accessibilité des données personnelles.
          </p>

          <h2>Les préférences de communication</h2>
          <p>
          Le Client peut personnaliser et gérer les préférences disponibles en matière de communication et d’autres
          configurations en mettant à jour ses préférences de compte, ou, le cas échéant, en utilisant le mécanisme de
          retrait ou de désabonnement, notamment aux notifications émises pour le compte des enseignes référencées.
          Clean Bill se réserve le droit d’avertir le Client des modifications et mises à jour apportées aux Solutions
          Clean Bill.
          </p>

          <h2>Accès aux données par le Client</h2>
          <p>
          Le Client accède librement à ses données personnelles, peut les rectifier ou les supprimer, restreindre le
          périmètre de traitement par Clean Bill ou encore faire une copie des données personnelles (droit à la
          portabilité).
          Le client peut exercer ses droits en formulant une demande à Clean Bill, via l’Application, le Site Internet
          ou par courrier à l’attention de Clean bill, 9 b chemin de l’Usclade 30340 SAINT-PRIVAS-DES-VIEUX.
          </p>

          <h2>Modifications</h2>
          <p>
          La présente Politique de Confidentialité est régulièrement mise à jour. Toute modification sera publiée via
          les Solutions Clean Bill et sera portée à la connaissance du Client par des notifications spécifiques.
          </p>

          <h2>Contact</h2>
          <p>
          Toute demande portant sur la politique de conservation ou de traitement des données personnelles peut être
          adressée à Clean Bill par courrier à l’adresse suivante : 9 b chemin de l’Usclade 30340
          SAINT-PRIVAS-DES-VIEUX.
          Toute plainte peut être déposée auprès de la Commission Nationale de l’Informatique et des Libertés (CNIL),
          régulateur des données personnelles en France.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Privacy;
